import styled from '@emotion/styled'

export const ChameleonLink = styled.a`
  color: inherit;
`
